import {
  AttachmentPreviewListProps,
  useAttachmentManagerState,
  useMessageComposer,
} from 'stream-chat-react';
import { UnsupportedAttachmentPreview as DefaultUnknownAttachmentPreview } from './unsupported-attachment-preview';
import { FileAttachmentPreview as DefaultFilePreview } from './file-attachment-preview';
import { ImageAttachmentPreview as DefaultImagePreview } from './image-attachment-preview';
import { VoiceRecordingPreview as DefaultVoiceRecordingPreview } from './voice-recording-preview';
import { PdfAttachmentPreview } from './pdf-attachment-preview';
import {
  isScrapedContent,
  isLocalVoiceRecordingAttachment,
  isLocalAudioAttachment,
  isLocalImageAttachment,
  isLocalVideoAttachment,
  isLocalFileAttachment,
  LocalAttachment,
  isLocalAttachment,
} from '../stream-attachment-types';

export const CustomAttachmentPreviewList = ({
  AudioAttachmentPreview = DefaultFilePreview,
  FileAttachmentPreview = DefaultFilePreview,
  ImageAttachmentPreview = DefaultImagePreview,
  UnsupportedAttachmentPreview = DefaultUnknownAttachmentPreview,
  VideoAttachmentPreview = DefaultFilePreview,
  VoiceRecordingPreview = DefaultVoiceRecordingPreview,
}: AttachmentPreviewListProps) => {
  const messageComposer = useMessageComposer();

  const { attachments } = useAttachmentManagerState();

  if (!attachments.length) return null;

  return (
    <div className="str-chat__attachment-preview-list">
      <div
        className="str-chat__attachment-list-scroll-container"
        data-testid="attachment-list-scroll-container"
      >
        {attachments.map((attachment) => {
          if (isScrapedContent(attachment as unknown as LocalAttachment)) return null;
          if (isLocalVoiceRecordingAttachment(attachment as unknown as LocalAttachment)) {
            return (
              <VoiceRecordingPreview
                // @ts-expect-error - TODO: fix this
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id || attachment.asset_url}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          } else if (isLocalAudioAttachment(attachment as unknown as LocalAttachment)) {
            return (
              <AudioAttachmentPreview
                // @ts-expect-error - TODO: fix this
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id || attachment.asset_url}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          } else if (isLocalVideoAttachment(attachment as unknown as LocalAttachment)) {
            return (
              <VideoAttachmentPreview
                // @ts-expect-error - TODO: fix this
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id || attachment.asset_url}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          } else if (isLocalImageAttachment(attachment as unknown as LocalAttachment)) {
            return (
              <ImageAttachmentPreview
                // @ts-expect-error - TODO: fix this
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id || attachment.image_url}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          } else if (isLocalFileAttachment(attachment as unknown as LocalAttachment)) {
            // mime type with Stream is not always present
            if (attachment.mime_type == 'application/pdf' || attachment.title?.endsWith('.pdf')) {
              return (
                <PdfAttachmentPreview
                  // @ts-expect-error - TODO: fix this
                  attachment={attachment}
                  handleRetry={messageComposer.attachmentManager.uploadAttachment}
                  key={attachment.localMetadata.id || attachment.asset_url}
                  removeAttachments={messageComposer.attachmentManager.removeAttachments}
                />
              );
            }

            return (
              <FileAttachmentPreview
                // @ts-expect-error - TODO: fix this
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id || attachment.asset_url}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          } else if (isLocalAttachment(attachment as unknown as LocalAttachment)) {
            return (
              <UnsupportedAttachmentPreview
                attachment={attachment}
                handleRetry={messageComposer.attachmentManager.uploadAttachment}
                key={attachment.localMetadata.id}
                removeAttachments={messageComposer.attachmentManager.removeAttachments}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};
